export default __webpack_public_path__ + "static/media/SBA_2020_Home_1280_2_00040.224fe8aa.png";